/* global FooterLinks */
// original file system/application/views/layout/pages_foot.php
$(() => {
    /**
     * Handle Footer Link Click.
     *
     * @param {Node}   el   - the li element
     * @param {String} path - the URL
     */
    const handleFooterLinkClick = (el, path) => {
        $(el).on("click", () => {
            renderFooterLinks(path);
        });
    };

    /**
     * Function to render footer links
     *
     * @param {string} current_url - The current URL
     */
    const renderFooterLinks = (current_url) => {
        const footerLinksContainer = $('#footerLinksSite');
        footerLinksContainer.empty();

        Object.entries(FooterLinks.sections).forEach(([sectionKey, sectionTitle]) => {

            if (!FooterLinks.sections.hasOwnProperty(sectionKey)) return;

            // Create list for links
            const linksList = document.createElement("ul");
            const sectionLinks = FooterLinks.links[sectionKey];

            Object.entries(sectionLinks).forEach(([linkKey, linkData]) => {
                // Create list item for each link
                const listItem = document.createElement("li");
                
                // Create descriptive aria-label for better accessibility
                const ariaLabel = linkData.identifier === "More Avas Flowers" 
                    ? "View complete list of Avas Flowers websites and services"
                    : `Go to ${linkData.identifier}`;

                if (linkData.is_external_link === "1") {
                    listItem.innerHTML = `<a href="${linkData.path}" aria-label="${ariaLabel}">${linkData.identifier}</a>`;
                } else {
                    if (linkData.path === current_url && linkData.apply_active_page_mode === "1") {
                        listItem.className = "active";
                        listItem.textContent = linkData.alternate_active_link_text || linkData.identifier;
                    } else {
                        listItem.innerHTML = `<a href="${linkData.path}" aria-label="${ariaLabel}">${linkData.identifier}</a>`;
                    }
                }
                
                handleFooterLinkClick(listItem, linkData.path);
                linksList.appendChild(listItem);
            });

            // Create section container
            const sectionDiv = document.createElement("div");
            sectionDiv.className = "footLinkBox footLinkBox4Col";
            sectionDiv.innerHTML = `<h3>${sectionTitle}</h3>`;
            sectionDiv.appendChild(linksList);

            footerLinksContainer.append(sectionDiv);
        });
    };

    // Initialize footer links if available
    if (typeof FooterLinks !== 'undefined' && FooterLinks.sections && FooterLinks.links) {
        const currentUrl = window.location.href.replace(/\/+$/, "");
        renderFooterLinks(currentUrl);
    }

    // Add GoDaddy site seal
    const siteSealSpan = document.getElementById('siteseal');
    if (siteSealSpan) {
        const siteSeal = document.createElement("script");
        siteSeal.type = "text/javascript";
        siteSeal.async = true;
        siteSeal.src = "https://seal.godaddy.com/getSeal?sealID=VGglttpS1oajCnQPaVDVppV4fRDlTXF8WOVi8uiIKFrK2RamYHynszsefZaw";
        siteSealSpan.appendChild(siteSeal);
    }
});
